module.exports = __webpack_public_path__ + "3b5fda9de360952c0e4b09e24e403aef.svg";